import { styled } from '@mui/material';
import { PropsWithChildren } from 'react';

import { Typography } from '../../Typography';

const StyledSubtitle = styled(Typography)({
  lineHeight: '21px',
  color: 'var(--color-general-grey-500)',
});

export const Subtitle = ({ children }: PropsWithChildren) => {
  return <StyledSubtitle variant="h2">{children}</StyledSubtitle>;
};
